











































































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Flight, Airline, BusTrip, ApiError } from '@/api';
import { snackModule, authModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import RelAutocomplete from '@/components/RelAutocomplete.vue';
import RelSelect from '@/components/RelSelect.vue';
import TimePicker from '@/components/TimePicker.vue';

@Component({
  components: {
    ConfirmDialog,
    RelAutocomplete,
    RelSelect,
    TimePicker,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  flight: Flight | null = null;

  timetable: Array<{
    text: string | number | object;
    value: string | number | object;
    disabled?: boolean;
    divider?: boolean;
    header?: string;
  }> = [
    { text: 'Weekday', value: 'weekday' },
    { text: 'Weekend', value: 'weekend' },
  ];

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredObject = [
    (v: Airline | BusTrip) => {
      if (!v) {
        return 'This field is required';
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || 'This field is required'
      );
    },
  ];

  busTripScopeFactory() {
    return BusTrip.order({ departureTime: 'asc' });
  }

  get busTripWhere() {
    if (!this.flight || !this.flight.service) {
      return;
    }
    return { service: this.flight.service };
  }

  get time() {
    if (!this.flight || !this.flight.time) {
      return;
    }

    return moment(this.flight.time, 'HH:mm').format('h:mm a');
  }

  get flightId() {
    return this.$route.params.flightId;
  }

  airlineScopeFactory() {
    return Airline.includes([]);
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.flight && this.flight.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  async save() {
    if (!this.flight) {
      return;
    }

    try {
      if (!this.flight.departure) {
        this.flight.busTrip = null;
      }
      await this.flight.save({ with: ['airline.id', 'busTrip.id'] });

      if (
        this.$route.name === 'admin-flights-add' &&
        this.flight &&
        this.flight.id
      ) {
        this.$router.push({
          name: 'admin-flights-edit',
          params: { flightId: this.flight.id },
        });
        snackModule.showSnackbar('Flight Created');
      } else {
        snackModule.showSnackbar('Flight Updated');
      }
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    if (this.$route.name === 'admin-flights-edit' && this.flightId) {
      try {
        this.flight = (await Flight.find(this.flightId)).data;
      } catch (err) {
        // most likely this means not found
        snackModule.showSnackbar('Flight not found');
      }
    } else {
      this.flight = new Flight();
      this.flight.service = String(this.timetable[0].value);
    }
  }
}
